KMVP.kmcQuoteEditModalValidation = {
    bind: function() {
        $('.js-quote-edit-input-quantity').change(KMVP.kmcQuoteEditModalValidation.validate.bind(this))
                                          .keyup(KMVP.kmcQuoteEditModalValidation.validate.bind(this));
    },
    negativeNumberErrorMessageText: 'The value must be 0 or more',
    notIntegerErrorMessageText: 'The value must be a whole number',
    notNumberErrorMessageText: 'The value must be a number',
    validate: function() {
        var value = $('.js-quote-edit-input-quantity').val();
        if (this.isNegativeNumber(value)) {
            this.showErrorMessage(this.negativeNumberErrorMessageText);
        } else if (!this.isValueNumber(value)) {
            this.showErrorMessage(this.notNumberErrorMessageText);
        } else if (!this.isValueInteger(value)) {
            this.showErrorMessage(this.notIntegerErrorMessageText);
        } else {
            this.hideErrorMessage();
        }
    },
    isNegativeNumber: function(value) {
        var numberValue = Number(value);
        return typeof numberValue === "number" && numberValue < 0
    },
    isValueNumber: function(value) {
        return !((value === '') || value.includes('e') || value.includes('+') || value.includes('-'));
    },
    isValueInteger: function(value) {
        return Math.round(value) === Number(value) && !(value.includes(',') || value.includes('.'));
    },
    showErrorMessage: function(message) {
        $('.js-quote-entry-quantity-data').addClass('error');
        $('.js-quote-entry-quantity-error-message').text(message);
        $('.js-confirm-quote-line-item-edit').attr('disabled', true);
    },
    hideErrorMessage: function() {
        $('.js-quote-entry-quantity-data').removeClass('error');
        $('.js-quote-entry-quantity-error-message').text('');
        $('.js-confirm-quote-line-item-edit').attr('disabled', false);
    }
};

$(document).ready(function() {
    if ($('.js-kmc-quote-detail-page.js-kmc-quote-status-quote').length) {
        KMVP.kmcQuoteEditModalValidation.bind();
    }
});
